import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { selectSelectionPanel } from '../../../features/ui/selectors';
import { closeSelectionPanel } from '../../../features/ui/uiSlice';
import { useAppSelector } from '../../../hooks';

export const useCanvasClickHandler = () => {
  const dispatch = useDispatch();
  const selectionPanelType = useAppSelector(selectSelectionPanel);

  // TODO: add an event listener, which can be removed on unmount, within the selection panel itself instead
  const handleGraphEditorClick = useCallback(() => {
    if (selectionPanelType !== null) {
      dispatch(closeSelectionPanel());
    }
  }, [dispatch, selectionPanelType]);

  return {
    handleGraphEditorClick,
  };
};
